import { Pipe, PipeTransform } from '@angular/core';
import { DiscountMode, DiscountTypeDto } from '@up/data';
@Pipe({
  name: 'applyDiscountMode'
})
export class DiscountModePipe implements PipeTransform {
  public constructor() {}
  transform(discount: Partial<DiscountTypeDto>, currency?: any): string {
    if (discount) {
      return DiscountMode[discount.discountModeId] === DiscountMode[1]
        ? '%'
        : currency && currency.symbol? currency.symbol : currency;
    }
    return '';
  }
}
